/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TaskGoalYearLevelInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class TaskGoalYearLevelApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'TaskGoalYearLevels');
  }

  setTaskGoalYearLevelsForTask(
    taskId: number,
    taskGoalYearLevels: TaskGoalYearLevelInterface[]
  ): Observable<TaskGoalYearLevelInterface[]> {
    return this.post(`task/${taskId}`, undefined, taskGoalYearLevels);
  }
}
